export type AlertMessage = {
  title: string | null;
  variant: string;
  accessibleTextIcon: string;
};

export type ButtonItem = {
  tooltipText: string;
  icon: string;
  accessibleText: string;
};

export type AttachedFilesRowData = [
  {
    value: string;
    variant?: string;
    alertMessage?: AlertMessage
  },
  {
    status?: string,
    progressBar?: {
      progressPercentage: number,
      accessibleText: string
    } | null
  }?,
  {
    buttonItems?: ButtonItem[] | null
  }?
];

export enum FileUploadStatus {
  FAILED = 0,
  SUCCESS = 1,
  PARTIAL_SUCCESS = 2
}

export interface ClpError {
  type: string;
  subtype: string;
  message: string;
}
